<template>
  <div class="ar-button">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ArButton',

  componentName: 'ArButton'
  
};
</script>
<style lang="scss" scoped>
.ar-button + .ar-button{
  margin-left: 10px;
}
.ar-button{
  height:36px;
  display: inline-block;
  color: #38A4FF;
  background: #FFF;
  border:1px solid #38A4FF;
  border-radius:6px;
  line-height: 32px;
  box-sizing: border-box;
  font-size:14px;
  padding: 0 20px;
  cursor: pointer;
  user-select: none;
  &:hover{
    color: #FFF;
    background: #38A4FF;
  }
  &:active{
    color: #FFF;
    border-color: #008AFF;
    background: #008AFF;
  }
  &.solid{
    background: #38A4FF;
    border-radius: 6px;
    color: #FFF;
    &:hover{
      border-color: #008AFF;
      background: #008AFF;
    }
    &:active{
      border-color: #0481EA;
      background: #0481EA;
    }
  }
  &.danger{
    border-color: #FF818D;
    background: #FF818D;
    border-radius: 6px;
    color: #FFF;
    &:hover{
      border-color: #FF5A6A;
      background: #FF5A6A;
    }
    &:active{
      border-color: #E94958;
      background: #E94958;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/anyUI/button/button.vue